// libs
import { styled } from '@nykaa/ui-components';

// global components
import ProductPlaceholder from 'shared/components/Product/Placeholder';

import { MEDIA_BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.section`
  content-visibility: auto;
  contain-intrinsic-size: 1900px;

  ${MEDIA_BREAKPOINTS.MOBILE} {
    padding: ${({ theme }) => `0 ${theme.spacing.spacing50}`};
    width: 100%;
  }

  ${MEDIA_BREAKPOINTS.TABLET} {
    padding: ${({ theme }) => `0 ${theme.spacing.spacing60}`};
    width: 100%;
  }

  max-width: 1200px;
  margin: 0 auto;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing120}`};

  & > .title {
    padding: ${({ theme }) => `${theme.spacing.spacing50} 0`};

    &:before {
      content: '';
      width: 100%;
      height: 1px;
      background: #000;
      margin-bottom: ${({ theme }) => theme.spacing.spacing100};
      display: block;
    }

    &:after {
      content: '';
      height: 20px;
      width: 240px;
      background: #f4f4f4;
      display: block;
      margin-bottom: ${({ theme }) => theme.spacing.spacing50};
    }
  }

  & > .container {
    max-width: 1080px;
    margin: 0 auto;
    overflow-x: auto;
    margin-bottom: ${({ theme }) => theme.spacing.spacing80};

    & > .content {
      display: flex;
    }
  }
`;

export const StyledProductPlaceholder = styled(ProductPlaceholder)`
  ${MEDIA_BREAKPOINTS.MOBILE} {
    width: calc(50vw - 15px);
    margin-right: ${({ theme }) => theme.spacing.spacing20};
    flex-shrink: 0;
  }

  ${MEDIA_BREAKPOINTS.TABLET} {
    width: calc(50vw - 23px);
    margin-right: ${({ theme }) => theme.spacing.spacing80};
    flex-shrink: 0;
  }

  width: calc(25% - 12px);
  margin-right: ${({ theme }) => theme.spacing.spacing80};
`;
